__turbopack_context__.v({
  "lds-dual-ring": "FormPreloader-module-scss-module__GwKl9q__lds-dual-ring",
  "ldsDualRing": "FormPreloader-module-scss-module__GwKl9q__ldsDualRing",
});
